export default "__VITE_ASSET__Dbt9yRyG__"